import { render, staticRenderFns } from "./topic-board.vue?vue&type=template&id=28a80ae6&scoped=true&"
import script from "./topic-board.vue?vue&type=script&lang=js&"
export * from "./topic-board.vue?vue&type=script&lang=js&"
import style0 from "./topic-board.vue?vue&type=style&index=0&id=28a80ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a80ae6",
  null
  
)

export default component.exports